export const valueKey: { [key: string]: string } = {
  canceled_accounts: "Canceled accounts",
  expected: "Expected sum",
  total: "Total sum",
  academic_growth: "Academic growth",
  financial_management: "Financial management",
  health_activity: "Health activity",
  organize_calendar: "Organize calendar",
  pet: "Pet",
  professional_progress: "Professional progress",
  property: "Property",
  vehicle: "Vehicle",
};
